(() => {
	angular.module('main').controller('TlcController', TlcController);

	TlcController.$inject = ['$scope', '$rootScope'];

	function TlcController($scope, $rootScope) {
		$scope.$on('$viewContentLoaded', () => {
			$rootScope.signInPage = false;
		});

		$rootScope.showLogo = false;
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/login/tlcController.js